<template>
  <div id="main-box" class="page-content">
    <div class="home-box">
      <div class="swiper-container home-hint">
        <div class="swiper-wrapper">
          <div class="swiper-slide notice-row" v-for="item in notice" v-text="item"></div>
        </div>
      </div>

      <div class="nav-box">
        <ul class="nav-main" v-for="(item,index) in navlist" v-on:click="OpenPage('MemberOrder',item.id)">
          <li class="nav-main-icon"><i class="fa" :class="item.icon"></i></li>
          <li class="nav-main-right">
            <p v-text="item.name"></p>
            <p v-text="item.count"></p>
          </li>
        </ul>
      </div>
    </div>

    <div class="chart-box" v-if="uid == 2">
      <div class="chart-box-row" style="width: 100%;margin-left: 0;" id="ConsumeChart"></div>
    </div>
    <div class="chart-box" v-else>
      <div class="chart-box-row" id="ConsumeChart"></div>
      <div class="chart-box-row" id="CreditChart"></div>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>


  </div>
</template>

<script>
  var self, ConsumeChart, CreditChart;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  export default {
    name: 'AdminHome',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
    },
    data() {
      return {
        uid: null,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        notice: [
          "2021年9月20日起，续重运费将从0.5元/kg，调整为1元/kg，感谢您的支持，祝商祺！",
          "ExShopee上架功能开启，点击上方导航 “上架” 按钮，免费使用吧！",
          "新用户注册可免费获赠5积分！",
        ],
        hint: "系统提示： 新用户注册可免费获赠5积分！",
        isLogin: true,
        money: 0,
        navlist: [{
          id: 1,
          count: 0,
          icon: "fa-cloud",
          name: "订单总数"
        }, {
          id: 2,
          count: 0,
          icon: "fa-star",
          name: "待打包订单"
        }, {
          id: 3,
          count: 0,
          icon: "fa-cloud-upload",
          name: "已完成订单"
        }, {
          id: 4,
          count: 0,
          icon: "fa-exclamation-circle",
          name: "异常订单"
        }, {
          id: 5,
          count: 0,
          icon: "fa-hashtag",
          name: "已关闭订单"
        }],
        orders: []
      }
    },
    mounted() {
      self = this;
      self.GetDatas();

      self.uid = localStorage.getItem("ExShopee_id");

      //屏幕宽度改变图表自动适应
      window.addEventListener('resize', function() {
        self.ChangeChartWidth();
      })

      //滚动公告
      var mySwiper = new Swiper('.swiper-container', {
        autoplay: {
          delay: 3000,
        },
        loop: true,
        direction: 'vertical',
      })

    },
    methods: {
      orderLine() {
        // 基于准备好的dom，初始化echarts实例
        ConsumeChart = self.$echarts.init(document.getElementById('ConsumeChart'))
        var datas = self.orders;
        var numlist = [],
          datelist = [];
        for (let item in datas) {
          numlist.push(datas[item])
          datelist.push(item)
        }

        let option = {
          title: {
            top: 20,
            left: 20,
            text: '订单数量（站点总和）',
            subtext: 'Quantity of order'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            top: 90,
            left: 55,
            bottom: 30,
            right: 40,
            borderColor: "#F00"
          },
          xAxis: {
            type: 'category',
            data: datelist,
            axisLine: {
              show: false,
              lineStyle: {
                color: ['rgba(128, 128, 128,0.8)'],
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: ['rgba(128, 128, 128,0.6)'],
              }
            }
          },
          series: [{
            data: numlist,
            type: 'line',
            symbolSize: 10,
            itemStyle: {
              color: "#65bdf8",
              borderWidth: 3
            }
          }]
        };

        // 绘制图表
        ConsumeChart.setOption(option);
      },
      creditLine() {
        // 基于准备好的dom，初始化echarts实例
        CreditChart = self.$echarts.init(document.getElementById('CreditChart'))
        var datas = self.credit;
        var moneylist = [],
          numlist = [],
          datelist = [];
        for (let item in datas) {
          numlist.push(datas[item].bale_count)
          moneylist.push((datas[item].bale_sum_money).toFixed(2))
          datelist.push(item)
        }

        let option = {
          title: {
            top: 20,
            left: 20,
            text: '打包统计（用户总和）',
            subtext: 'Quantity of order'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            top: 22,
            data: ['打包数量', '打包总额']
          },
          grid: {
            top: 90,
            left: 55,
            bottom: 30,
            right: 40,
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: datelist,
            axisLine: {
              show: false,
              lineStyle: {
                color: ['rgba(128, 128, 128,0.8)'],
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              show: false,
              lineStyle: {
                color: ['rgba(128, 128, 128,0.8)'],
              }
            }
          },
          series: [{
            name: '打包数量',
            type: 'line',
            stack: '总量',
            data: numlist,
            symbolSize: 10,
            itemStyle: {
              color: "#65bdf8",
              borderWidth: 3
            }
          },
          {
            name: '打包总额',
            type: 'line',
            stack: '总量',
            data: moneylist,
            symbolSize: 10,
            itemStyle: {
              color: "#f96868",
              borderWidth: 3
            }
          }]
        };

        // 绘制图表
        CreditChart.setOption(option);
      },
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      GetDatas() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_exshopee_index_static/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.loading = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            var json = datas;
            var navlist = self.navlist;
            for (let item in navlist) {
              navlist[item].count = json.count_arr[item]
            }
            self.navlist = navlist;
            self.orders = json.list;
            self.credit = json.bale_statics_list;

            self.orderLine();
            if (self.uid != 2) {
              self.creditLine();
            }
          });

        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      OpenPage(url, data) {
        localStorage.setItem("ExShopee_HistoryURL", url);
        if (data) {
          self.GoToPage('/' + url + '?te=' + data); // 路由跳转
        } else {
          self.GoToPage('/' + url); // 路由跳转
        }
      },
      ChangeChartWidth() {
        ConsumeChart.resize();
        CreditChart.resize();
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .home-box {
    padding: 20px 20px 0 20px;
  }

  .nav-box {
    overflow: hidden;
  }

  .nav-main {
    float: left;
    width: calc(18.39% - 40px);
    background-color: #33cabb;
    margin-right: 2%;
    padding: 30px 20px;
    ;
    cursor: pointer;
    border-radius: 5px;
  }

  .nav-main:hover {
    opacity: 0.9;
  }

  .nav-main:last-child {
    margin-right: 0%;
  }

  .nav-main-icon {
    display: inline-block;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    color: #FFF;
    float: left;
    text-align: center;
    font-size: 1.5em;
    line-height: 48px;
    background-color: rgba(255, 255, 255, 0.175);
  }

  .nav-main-icon img {
    display: table;
    width: 100%;
  }

  .nav-main-left {
    float: left;
  }

  .nav-main-right {
    float: right;
    color: #FFF;
  }

  .nav-main-right p:first-child {
    font-size: 14px;
  }

  .nav-main-right p:last-child {
    font-size: 2em;
    margin-top: 10px;
    text-align: center;
  }

  .nav-main:nth-child(1) {
    background-color: #33cabb;
  }

  .nav-main:nth-child(2) {
    background-color: #65bdf8;
  }

  .nav-main:nth-child(3) {
    background-color: #15c377;
  }

  .nav-main:nth-child(4) {
    background-color: #f96868;
  }

  .nav-main:nth-child(5) {
    background-color: #926dde;
  }

  .home-mian {
    overflow: hidden;
  }

  .home-mian-left {
    width: 230px;
    float: left;
    margin: 20px 0 20px 20px;
  }

  .home-mian-right {
    float: left;
    overflow: hidden;
    width: calc(100% - 290px);
    padding: 20px;
  }

  .home-mian-row {
    height: 210px;
    border-radius: 5px;
    background-color: #FFF;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  }

  .home-main-title {
    font-size: 15px;
    color: #666;
    padding: 15px 20px;
  }

  .home-main-count {
    text-align: center;
    font-size: 2em;
    margin: 30px 0;
    color: #f60;
  }

  .home-main-btnArr {
    overflow: hidden;
    display: table;
    margin: 0 auto;
    margin-bottom: 20px;

  }

  .home-main-btnArr a {
    float: left;
    display: table;
    padding: 10px 15px;
    margin-right: 10px;
    border-radius: 5px;
    border: 1px solid #EEE;
    cursor: pointer;
  }

  .home-main-btnArr a:hover {
    color: #000;
    background-color: #F9F9F9;
  }

  .home-mian-right-contact {
    float: left;
    width: 49%;
    margin-right: 2%;
  }

  .home-mian-right-address {
    float: left;
    width: 49%;
  }

  .home-mian-right-row {
    padding: 0 25px;
    padding-bottom: 20px;
    border-top: 1px solid #f3f3f3;
  }

  .home-mian-right-row ul li {
    overflow: hidden;
  }

  .home-mian-right-row ul li p {
    float: left;
    margin-top: 11px;
    font-size: 15px;
    line-height: 22px;
    color: #333;
  }

  .home-mian-right-row ul li p:first-child {
    width: 70px;
  }

  .home-mian-right-row ul li p:last-child {
    width: calc(100% - 70px);
  }

  .home-mian-right-row a {
    display: table;
    padding: 1px 3px;
    border-radius: 50px;
    color: #fff;
    background: rgba(101, 189, 248, 0.8)
  }

  .home-mian-right-contact-box ul li p:first-child {
    width: 53px;
  }

  .chart-box {
    overflow: hidden;
    margin-top: 20px;
    position: relative;
    padding: 0 20px 20px 20px;
  }

  .chart-box-row {
    width: 49%;
    float: left;
    height: 350px;
    border-radius: 5px;
    background-color: #FFF;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  }

  .chart-box-row:last-child {
    margin-left: 2%;
  }
</style>



// WEBPACK FOOTER //
// src/components/deliveryman/HomePage.vue